export { default } from './ExpansionPanel';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/ExpansionPanel/index.js
// module id = 671
// module chunks = 0